





















import { defineComponent, computed } from '@vue/composition-api';
import { dragFileHandler } from '@/renderer/components/SpacePage/compositions/dragFileHandler';
export default defineComponent({
  setup() {
    const badgeCount = computed(() =>
      dragFileHandler.dragWidgetFileCount.value > 1 ? dragFileHandler.dragWidgetFileCount.value : 0,
    );
    return {
      show: dragFileHandler.shouldShowDragWidget,
      size: dragFileHandler.dragWidgetSize,
      pos: dragFileHandler.dragWidgetPos,
      mainFile: dragFileHandler.dragWidgetFileItem,
      fileCount: dragFileHandler.dragWidgetFileCount,
      badgeCount,
    };
  },
});
